/* eslint-disable max-lines */
import { Box, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  INVALID_FORMAT_ERR,
  MANDATORY_FIELD_ERR,
  SAME_BENEFICIARY_ADDRESS,
  VALIDATION_BACKSPACE,
} from '../../../constants';
import { commonUtility } from '../UtilityFunctions';
import { isWebComponentFlow } from '../../commonCode';
import CustomSwitch from '../Switch/CustomSwitch';
import MailingAddress from '../StepOne/MailingAddress';
import { BeneficiaryCompStyles as classes } from './BeneficiaryCompStyles';

const BeneficiaryAddressInfo = () => {
  const { t } = useTranslation();
  const baseContext = isWebComponentFlow();
  const {
    beneficiaryData,
    setBeneficiaryData,
    setBeneficiaryDataErrors,
    addressInformation,
    selectedAddress,
    loginHomeAddress,
    flowTypeETB,
    setIsBeneficiaryScreenDirty,
    setIsScreenFiveDirty,
    setIsFundingScreenDirty,
  } = baseContext;

  const addressContext = flowTypeETB === 'EtbFlow' ? loginHomeAddress : addressInformation;

  const handleToggleChange = (e) => {
    setIsBeneficiaryScreenDirty(true);
    setIsScreenFiveDirty(true);
    setIsFundingScreenDirty(true);
    if (e.target.checked === true) {
      if (selectedAddress?.AddressId) {
        setBeneficiaryData((prevState) => ({
          ...prevState,
          addressInfo: {
            sameBeneficiaryAddress: e.target.checked,
            beneficiaryAddress1: selectedAddress?.LineOne ? selectedAddress.LineOne : '',
            beneficiaryAddress2: selectedAddress?.LineTwo ? selectedAddress.LineTwo : '',
            beneficiaryCity: selectedAddress?.AddrCity ? selectedAddress.AddrCity : '',
            beneficiaryCountry: selectedAddress?.AddrCountry,
            beneficiaryState: selectedAddress?.AddrState,
            beneficiaryZipCode: selectedAddress?.ZipCode ? selectedAddress.ZipCode : '',
          },
        }));
      } else {
        setBeneficiaryData((prevState) => ({
          ...prevState,
          addressInfo: {
            sameBeneficiaryAddress: e.target.checked,
            beneficiaryAddress1: addressContext?.address1 ? addressContext.address1 : '',
            beneficiaryAddress2: addressContext?.address2 ? addressContext.address2 : '',
            beneficiaryCity: addressContext?.city ? addressContext.city : '',
            beneficiaryCountry: addressContext?.country,
            beneficiaryState: addressContext?.state,
            beneficiaryZipCode: addressContext?.zipCode ? addressContext.zipCode : '',
          },
        }));
      }
      setBeneficiaryDataErrors((prevState) => ({
        ...prevState,
        addressInfo: {
          beneficiaryAddress1: '',
          beneficiaryAddress2: '',
          beneficiaryCity: '',
          beneficiaryCountry: '',
          beneficiaryState: '',
          beneficiaryZipCode: '',
        },
      }));
    } else if (e.target.checked === false) {
      const defaultCountry = addressInformation?.defaultCountryBasedOnLocation;
      setBeneficiaryData((prevState) => ({
        ...prevState,
        addressInfo: {
          sameBeneficiaryAddress: e.target.checked,
          beneficiaryAddress1: '',
          beneficiaryAddress2: '',
          beneficiaryCity: '',
          beneficiaryCountry: defaultCountry,
          beneficiaryState: defaultCountry === 'VI' || defaultCountry === 'PR' ? 'N/A' : '',
          beneficiaryZipCode: '',
        },
      }));
    }
  };
  const toggleOnEnter = (input) => {
    setIsBeneficiaryScreenDirty(true);
    setIsScreenFiveDirty(true);
    setIsFundingScreenDirty(true);
    if (input === 'sameBeneficiaryAddress') {
      const currentState = beneficiaryData?.addressInfo?.sameBeneficiaryAddress;
      const toggledState = !currentState;
      const defaultCountry = addressInformation?.defaultCountryBasedOnLocation;
      if (toggledState === false) {
        setBeneficiaryData((prevState) => ({
          ...prevState,
          addressInfo: {
            sameBeneficiaryAddress: toggledState,
            beneficiaryAddress1: '',
            beneficiaryAddress2: '',
            beneficiaryCity: '',
            beneficiaryCountry: defaultCountry,
            beneficiaryState: defaultCountry === 'VI' || defaultCountry === 'PR' ? 'N/A' : '',
            beneficiaryZipCode: '',
          },
        }));
      }
      if (toggledState === true) {
        if (selectedAddress?.AddressId) {
          setBeneficiaryData((prevState) => ({
            ...prevState,
            addressInfo: {
              sameBeneficiaryAddress: toggledState,
              beneficiaryAddress1: selectedAddress?.LineOne ? selectedAddress.LineOne : '',
              beneficiaryAddress2: selectedAddress?.LineTwo ? selectedAddress.LineTwo : '',
              beneficiaryCity: selectedAddress?.AddrCity ? selectedAddress.AddrCity : '',
              beneficiaryCountry: selectedAddress?.AddrCountry,
              beneficiaryState: selectedAddress?.AddrState,
              beneficiaryZipCode: selectedAddress?.ZipCode ? selectedAddress.ZipCode : '',
            },
          }));
        } else {
          setBeneficiaryData((prevState) => ({
            ...prevState,
            addressInfo: {
              sameBeneficiaryAddress: toggledState,
              beneficiaryAddress1: addressContext?.address1 ? addressContext.address1 : '',
              beneficiaryAddress2: addressContext?.address2 ? addressContext.address2 : '',
              beneficiaryCity: addressContext?.city ? addressContext.city : '',
              beneficiaryCountry: addressContext?.country,
              beneficiaryState: addressContext?.state,
              beneficiaryZipCode: addressContext?.zipCode ? addressContext.zipCode : '',
            },
          }));
        }
        setBeneficiaryDataErrors((prevState) => ({
          ...prevState,
          addressInfo: {
            beneficiaryAddress1: '',
            beneficiaryAddress2: '',
            beneficiaryCity: '',
            beneficiaryCountry: '',
            beneficiaryState: '',
            beneficiaryZipCode: '',
          },
        }));
      }
    }
  };
  const handleAddressChange = (e) => {
    setIsBeneficiaryScreenDirty(true);
    setIsScreenFiveDirty(true);
    setIsFundingScreenDirty(true);
    if (e.target.name === 'permanentAddress2') {
      handleChangeAddresstwo(e);
    } else if (e.target.name === 'permanentCountry') {
      handleChangeCountry(e);
    } else if (e.target.name === 'permanentState') {
      handleChangeState(e);
    } else if (e.target.name === 'permanentCity') {
      handleChangeCity(e);
    } else if (e.target.name === 'permanentZipCode') {
      handleChangeZipcode(e);
    }
  };
  const handleChangeAddresstwo = (e) => {
    if (e.target.value && e.target.value.length > 0) {
      if (
        e.target.value.match(/^[A-Za-z0-9'#@%&\\/.\-\s,]+$/) &&
        e.target.value?.length >= 2 &&
        e.target.value.length <= 30
      ) {
        setBeneficiaryData((prevState) => ({
          ...prevState,
          addressInfo: { ...prevState?.addressInfo, beneficiaryAddress2: e.target.value },
        }));
        setBeneficiaryDataErrors((prevState) => ({
          ...prevState,
          addressInfo: { ...prevState?.addressInfo, beneficiaryAddress2: '' },
        }));
      } else if (e.target.value.length > 30) {
        setBeneficiaryData((prevState) => ({
          ...prevState,
          addressInfo: { ...prevState?.addressInfo, beneficiaryAddress2: e.target.value },
        }));
        setBeneficiaryDataErrors((prevState) => ({
          ...prevState,
          addressInfo: {
            ...prevState?.addressInfo,
            beneficiaryAddress2: '* Address Line 2 should have max 30 characters.',
          },
        }));
      } else {
        setBeneficiaryData((prevState) => ({
          ...prevState,
          addressInfo: { ...prevState?.addressInfo, beneficiaryAddress2: e.target.value },
        }));
        setBeneficiaryDataErrors((prevState) => ({
          ...prevState,
          addressInfo: {
            ...prevState?.addressInfo,
            beneficiaryAddress2: '* Invalid address',
          },
        }));
      }
    } else {
      setBeneficiaryData((prevState) => ({
        ...prevState,
        addressInfo: {
          ...prevState?.addressInfo,
          beneficiaryAddress2: commonUtility(e.target.value),
        },
      }));
      setBeneficiaryDataErrors((prevState) => ({
        ...prevState,
        addressInfo: {
          ...prevState?.addressInfo,
          beneficiaryAddress2: '',
        },
      }));
    }
  };
  const handleChangeZipcode = (e) => {
    if (e.target?.value?.match(/^\d+$/) || e.key === VALIDATION_BACKSPACE) {
      setBeneficiaryData((prevState) => ({
        ...prevState,
        addressInfo: { ...prevState?.addressInfo, beneficiaryZipCode: e.target.value },
      }));
      setBeneficiaryDataErrors((prevState) => ({
        ...prevState,
        addressInfo: { ...prevState?.addressInfo, beneficiaryZipCode: '' },
      }));
      if (e.target.value.length < 5) {
        setBeneficiaryDataErrors((prevState) => ({
          ...prevState,
          addressInfo: {
            ...prevState?.addressInfo,
            beneficiaryZipCode: '* Zipcode should have 5 digits',
          },
        }));
      } else if (e.target.value?.match(/^0*$/g)) {
        setBeneficiaryDataErrors((prevState) => ({
          ...prevState,
          addressInfo: {
            ...prevState?.addressInfo,
            beneficiaryZipCode: '* Please enter a valid zipcode',
          },
        }));
      } else {
        setBeneficiaryDataErrors((prevState) => ({
          ...prevState,
          addressInfo: {
            ...prevState?.addressInfo,
            beneficiaryZipCode: '',
          },
        }));
      }
    } else if (e.target.value === '') {
      setBeneficiaryData((prevState) => ({
        ...prevState,
        addressInfo: { ...prevState?.addressInfo, beneficiaryZipCode: '' },
      }));
      setBeneficiaryDataErrors((prevState) => ({
        ...prevState,
        addressInfo: {
          ...prevState?.addressInfo,
          beneficiaryZipCode: MANDATORY_FIELD_ERR,
        },
      }));
    } else {
      setBeneficiaryData((prevState) => ({
        ...prevState,
        addressInfo: { ...prevState?.addressInfo, beneficiaryZipCode: e.target.value },
      }));
      setBeneficiaryDataErrors((prevState) => ({
        ...prevState,
        addressInfo: {
          ...prevState?.addressInfo,
          beneficiaryZipCode: INVALID_FORMAT_ERR,
        },
      }));
    }
  };
  const handleChangeCountry = (e) => {
    if (e.target.value && e.target.value.length > 0) {
      setBeneficiaryData((prevState) => ({
        ...prevState,
        addressInfo: {
          ...prevState?.addressInfo,
          beneficiaryCountry: e.target.value,
          beneficiaryState: e.target.value === 'PR' || e.target.value === 'VI' ? 'N/A' : '',
          beneficiaryCity: '',
        },
      }));
      setBeneficiaryDataErrors((prevState) => ({
        ...prevState,
        addressInfo: {
          ...prevState?.addressInfo,
          beneficiaryCountry: '',
          beneficiaryState: '',
          beneficiaryCity: '',
        },
      }));
    } else {
      setBeneficiaryData((prevState) => ({
        ...prevState,
        addressInfo: {
          ...prevState?.addressInfo,
          beneficiaryCountry: e.target.value ? e.target.value : '',
          beneficiaryState: e.target.value === 'PR' || e.target.value === 'VI' ? 'N/A' : '',
          beneficiaryCity: '',
        },
      }));
      setBeneficiaryDataErrors((prevState) => ({
        ...prevState,
        addressInfo: {
          ...prevState?.addressInfo,
          beneficiaryCountry: MANDATORY_FIELD_ERR,
        },
      }));
    }
  };
  const handleChangeState = (e) => {
    if (e.target.value && e.target.value.length > 0) {
      setBeneficiaryData((prevState) => ({
        ...prevState,
        addressInfo: {
          ...prevState?.addressInfo,
          beneficiaryState: e.target.value,
          beneficiaryCity: '',
        },
      }));
      setBeneficiaryDataErrors((prevState) => ({
        ...prevState,
        addressInfo: {
          ...prevState?.addressInfo,
          beneficiaryState: '',
          beneficiaryCity: '',
        },
      }));
    } else {
      setBeneficiaryData((prevState) => ({
        ...prevState,
        addressInfo: {
          ...prevState?.addressInfo,
          beneficiaryState: e.target.value ? e.target.value : '',
          beneficiaryCity: '',
        },
      }));
      setBeneficiaryDataErrors((prevState) => ({
        ...prevState,
        addressInfo: {
          ...prevState?.addressInfo,
          beneficiaryState: MANDATORY_FIELD_ERR,
        },
      }));
    }
  };
  const handleChangeCity = (e) => {
    if (e.target.value && e.target.value.length > 0) {
      setBeneficiaryData((prevState) => ({
        ...prevState,
        addressInfo: {
          ...prevState?.addressInfo,
          beneficiaryCity: e.target.value,
        },
      }));
      setBeneficiaryDataErrors((prevState) => ({
        ...prevState,
        addressInfo: {
          ...prevState?.addressInfo,
          beneficiaryCity: '',
        },
      }));
    } else {
      setBeneficiaryData((prevState) => ({
        ...prevState,
        addressInfo: {
          ...prevState?.addressInfo,
          beneficiaryCity: e.target.value ? e.target.value : '',
        },
      }));
      setBeneficiaryDataErrors((prevState) => ({
        ...prevState,
        addressInfo: {
          ...prevState?.addressInfo,
          beneficiaryCity: MANDATORY_FIELD_ERR,
        },
      }));
    }
  };

  return (
    <Grid>
      <Grid sx={classes.toggleContainer}>
        <Typography sx={classes.toggleText}>
          {t(SAME_BENEFICIARY_ADDRESS, {
            defaultValue: SAME_BENEFICIARY_ADDRESS,
          })}
        </Typography>
        <Box
          role="application"
          aria-roledescription={t(SAME_BENEFICIARY_ADDRESS, {
            defaultValue: SAME_BENEFICIARY_ADDRESS,
          })}
        >
          <CustomSwitch
            id="sameBeneficiaryAddress"
            ariaLabelName={`${t(SAME_BENEFICIARY_ADDRESS, {
              defaultValue: SAME_BENEFICIARY_ADDRESS,
            })}`}
            defaultData={!!beneficiaryData?.addressInfo?.sameBeneficiaryAddress}
            ariaLabelledby="toggleone"
            handleClickCheckbox={handleToggleChange}
            toggleCheckboxOnEnter={toggleOnEnter}
            dataTestId="sameBeneficiaryCheckbox"
          />
        </Box>
      </Grid>
      <MailingAddress handleChange={handleAddressChange} isBeneficiaryAddress />
    </Grid>
  );
};
export default BeneficiaryAddressInfo;

BeneficiaryAddressInfo.propTypes = {};
